import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useOrderQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const ordersQuery = useQuery({
        queryKey: ["order"],
        queryFn: () =>
            axiosPrivate
                .get("order/get_for_business/")
                .then(r => r.data)
    });

    const useOrderDetailQuery = (id) => useQuery({
            queryKey: ["order", id],
            queryFn: () =>
                axiosPrivate
                    .get(`order/${id}/`)
                    .then(r => r.data),
            enabled: !!id
        });


    // MUTATIONS ----------------------------------------------------

    const createOrderMutation = useMutation({
        mutationFn: (payload) =>
            axiosPrivate
                .post("order/", payload)
                .then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["order"]);
        }
    });

    const createInvoiceMutation = useMutation({
        mutationFn: ({ id, data }) =>
            axiosPrivate
                .post(`order/${id}/create_invoice/`, data)
                .then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries(['order'])
    });

    const sendInvoiceMutation = useMutation({
        mutationFn: ({ id, doc_id }) =>
            axiosPrivate
                .get(`order/${id}/send_invoice/?doc_id=${doc_id}`)
                .then(r => r.data)
    });

    const downloadInvoiceMutation = useMutation({
        mutationFn: ({ id, doc_id }) =>
            axiosPrivate
                .get(`order/${id}/download_invoice/?doc_id=${doc_id}`, {
                    responseType: "blob"
                })
                .then(r => r.data),
    });


    const deleteOrderMutation = useMutation({
        mutationFn: (id) =>
            axiosPrivate
                .delete(`order/${id}/`, {
                    responseType: "blob"
                })
                .then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries(['order'])
    });

    const useGetDocumentsQuery = (id) => useQuery({
            queryKey: ["order_documents", id],
            queryFn: () =>
                axiosPrivate
                    .get(`order/${id}/get_documents/`)
                    .then(r => r.data),
            enabled: !!id
        });

    // EXPORT -------------------------------------------------------

    return {
        // Queries
        ordersQuery,
        useOrderDetailQuery,
        useGetDocumentsQuery,

        // Mutations
        createOrderMutation,
        deleteOrderMutation,
        createInvoiceMutation,
        sendInvoiceMutation,
        downloadInvoiceMutation
    };
}
